module.exports = __webpack_public_path__ + "static/media/stepsMock.c9dd3e65.jpg";